// let dashboard = ""
let items = []



items.push(
  {
    name: 'Online',
    url: '/auth/live',
    icon: 'icon-puzzle',
  },
  // {
  //   name: 'Offline',
  //   url: '/auth/upload',
  //   icon: 'icon-puzzle',
  // },
  // {
  //   name: 'Report',
  //   url: '/auth/report',
  //   icon: 'icon-puzzle',
  // }
)  

export default { items };
